import React, { useEffect, useState } from "react";
import { SectionWrapper } from "../components/SectionWrapper";
import { IState } from "../features/profileAccountHook";
import { Switch } from "../components/Swtich";
import MarketingService from "@services/Marketing.service";
import { useAccountPageContext } from "../AcountPage.context";

type NewsletterProps = {
  fetchProfileData: () => void;
};

export const Newsletter = ({ fetchProfileData }: NewsletterProps) => {
  const { state } = useAccountPageContext();

  const [value, setValue] = useState(state?.emailNotificationData?.newsletter);

  const onChange = async (value: boolean) => {
    setValue(value);
    await MarketingService.updateNotificationSettings(value);

    fetchProfileData();
  };

  useEffect(() => {
    if (value !== state?.emailNotificationData?.newsletter) {
      setValue(state?.emailNotificationData?.newsletter);
    }
  }, [state?.emailNotificationData?.newsletter]);

  return (
    <SectionWrapper title="E-mail notifications">
      <div className="flex justify-between items-center">
        <div>Allow to receive newsletter</div>

        <Switch checked={value} onChange={onChange} />
      </div>
    </SectionWrapper>
  );
};
